import styles from "./Home.module.css";
import Image from "next/image";
import pin from "../../assets/images/header/pin.png";
import googleplay from "../../assets/images/home/googleplay.png";
import apple from "../../assets/images/home/apple.png";
import mobileimg from "../../assets/images/home/mobileimg.webp";
import AOS from "aos";
import "aos/dist/aos.css";
import CountUp from "react-countup";
import icon1 from "../../assets/images/home/newicon/Icon01.png";
import icons2 from "../../assets/images/home/newicon/icon03.png";
import icons3 from "../../assets/images/home/newicon/icon02.png";
import homeicon1 from "../../assets/images/home/newicon/siahome1.png";
import homeicon4 from "../../assets/images/home/newicon/siahome4.png";
import homeicon2 from "../../assets/images/home/newicon/siahome3.png";
import homeicon3 from "../../assets/images/home/newicon/siahome2.png";
import homeicon5 from "../../assets/images/home/newicon/siahome5.png";
import homeicon6 from "../../assets/images/home/newicon/siahome6.png";
import Webex from "../../assets/images/home/online-learning-64.png";
import Mobileapp from "../../assets/images/home/Current Affairs.png";
import Testpress from "../../assets/images/home/online-test.png";
import onlineinterview from "../../assets/images/home/online-interview-1.png";
import event from "../../assets/images/home/01Anbil.jpg";
import event1 from "../../assets/images/home/02Bvenka.jpg";
import event2 from "../../assets/images/home/03Nirmala.jpg";
import Carousel from 'react-bootstrap/Carousel';
import medal from "../../assets/images/home/medal.webp";
import event3 from "../../assets/images/home/chief-guest.jpg";
import redrightarrow from  "../../assets/images/contact/Rarrow.png";
import OnlineBanner from "../../assets/images/home/Smart-banner/online-class-banner.jpg";
import NewBanner from "../../assets/images/home/Smart-banner/Why-Chosse-SIA.jpg";
import Banner2 from "../../assets/images/home/Smart-banner/our-branches.jpg"; 
import icon2 from "../../assets/images/home/faculty.webp";
import icon3 from "../../assets/images/home/guidance.webp";
import icon4 from "../../assets/images/home/newicon/Web-Icons-04.png";
import icon5 from "../../assets/images/home/newicon/Web-Icons-05.png";
import icon6 from "../../assets/images/home/newicon/Web-Icons-06.png";
import chennai from "../../assets/images/header/Iconnnn-01.png";
import delhi from "../../assets/images/header/Iconnnn-02.png";
import bengaluru from "../../assets/images/header/Iconnnn-04.png";
import thiruvandram from "../../assets/images/header/Iconnnn-03.png";
import hyderabad from "../../assets/images/header/Iconnnn-05.png";
import preferredcivil from "../../assets/images/home/preferredcivil.webp";
import SIAHOME from "../../assets/images/home/siabuilding-2.png";
import Notifyicon from "../../assets/images/home/notification.gif";
import SIAINDIA from "../../assets/images/home/SIAMap.png";
//import SIAVIDEO from  "../../public/SIA-VIDEO.mp4";
import Himachal from "../../assets/images/home/Logo/Gv-logo-1.png";
import Meghalaya from "../../assets/images/home/Logo/Gv-logo-2.png";
import Bengal from "../../assets/images/home/Logo/Gv-logo-3.png";
import Karnataka from "../../assets/images/home/Logo/Gv-logo-4.png"; 
import Kerala from "../../assets/images/home/Logo/Gv-logo-5.png";
import Inidia from "../../assets/images/home/Logo/Gv-logo-6.png";
import Andhra from "../../assets/images/home/Logo/Gv-logo-7.png"; 
import Kashmir from "../../assets/images/home/Logo/Gv-logo-8.png"; 
import HimachalPradesh from "../../assets/images/home/Logo/Gv-logo-9.png";
import Collaboration from "../../assets/images/home/Logo/Gv-logo-10.png";
import Whychoose from "../../components/why-choose/index";
import WhychooseSIA from "../../components/why-choose-sia/index";
import youtube_thumnail_1 from "../../assets/images/home/youtube/youtube_thumnail_33.webp";
import youtube_thumnail_2 from "../../assets/images/home/youtube/Youtube-thumbnail-AIR-07-2026.jpg";
import youtube_thumnail_3 from "../../assets/images/home/youtube/Felicitation-programme-2024.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Close from "../../assets/images/home/Icon ionic-ios-close-circle.png";
// import Sadhana from "../../assets/images/home/Pre-book-2024_web-popup.webp";
import Upsc_popup from "../../assets/images/home/Moksha-Pop-up.jpg";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';
//import dynamic from "next/dynamic";
//const Acheiver = dynamic(() => import("../../components/our-acheiver/achievers"));
// import { useRef } from "react";
import Acheiver from "../../components/our-acheiver/achievers";
import Newicon from "../../assets/images/header/new.svg";
import NewiconA from "../../assets/images/header/newanimation.gif";
import Head from "next/head";
import Slider from "../../components/homeslider/slider"

const Homepage = () => {
const [modalIsOpen, setModalIsOpen] = useState(false);
const [activeTab, setActiveTab] = useState("upsc");
const [count, setCount] = useState(0);
const [showPlus, setShowPlus] = useState(false);
const [active, setActive] = useState(0); // default open card (0 = first)
const [activeIndex, setActiveIndex] = useState(0);
const [activeSlide, setActiveSlide] = useState(0);
const [upscSubTab, setUpscSubTab] = useState("foundation");

  const openModal = () => setModalIsOpen(true);
  const videoRef = useRef(null);
  const sectionRef = useRef(null);
  const audioUnlockedRef = useRef(false);

  // 🔓 Close modal + unlock audio
  const closeModal = () => {
    setModalIsOpen(false);

    const video = videoRef.current;
    if (!video) return;

    // Unlock browser audio permission
    video.muted = false;

    video.play()
      .then(() => {
        video.pause(); // immediately pause (just unlocking)
        audioUnlockedRef.current = true;
      })
      .catch(() => {});
  };

  // 🎬 Scroll play / pause logic
  useEffect(() => {
    const section = sectionRef.current;
    const video = videoRef.current;

    if (!section || !video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // If user closed modal, allow sound
          video.muted = !audioUnlockedRef.current;

          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);


// useEffect(() => {
//   if (typeof window === "undefined") return;

//   const timer = setTimeout(() => {
//     openModal();
//   }, 1000);

//   return () => clearTimeout(timer);
// }, []);



const upscCourses = {
  foundation: [
    {
      title: "I Year UPSC Foundation Course",
      link: "/upsc-admission-anna-nagar",
    },
    {
      title: "Sadhana (II Year UPSC  Course)",
      link: "/two-year-upsc-program",
    },

     {
      title: "UPSC 2026 Orientation Program ",
      link: "/two-year-upsc-program",
    },

     {
      title: "UPSC 2026 Orientation Program ",
      link: "/two-year-upsc-program",
    },

  ],

  testSeries: [
    {
      title: "UPSC Prelims Test Series 2026",
      link: "/upsc-admission-anna-nagar",
      highlight: true,
    },

    {
      title: "UPSC Mains Test Series 2026",
      link: "/upsc-admission-anna-nagar",
    },
  ],

  prelimsMains: [
    {
      title: "UPSC Mains Test Series (Foundation Course)",
      link: "/upsc-admission-anna-nagar",
    },
  ],

  interview: [
    {
      title: "UPSC Interview Guidance Programme",
      link: "/upsc-interview-guidance",
    },
  ],
};


  const events = [
    { img: event2, title: (<><div>Felicitation of</div> <div>2024 Achievers</div></>) },
    { img: event1, title: "20 Years Celebration" },
    { img: event, title: "Inauguration Day 2025  " }
  ];

  // Animation Section 

    useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      offset: 100,
    });
  }, []);

  // Animation Section End

  const banners = [
  {
    label: "WHY SIA ?",
    img: NewBanner,
    alt: "Why SIA",
    link: "/why-shankar-ias",
  },
  {
    label: "ONLINE CLASS",
    img: OnlineBanner,
    alt: "Online Classes",
    link: "https://play.google.com/store/apps/details?id=com.vinbytes.shankar_ias",
  },
  {
    label: "OUR BRANCHES",
    img: Banner2,
    alt: "Our Branches",
    link: "/upsc-admission-anna-nagar",
  },

 
];

const whyChooseCards = [
  {
    title: "Top-Notch Results",
    desc: "Produced 2,700+ IAS, IPS, IFS officers with proven success.",
    icon: icon1,
  },
  {
    title: "Online Classes – First in India",
    desc: "Two-way live interaction with faculty across India.",
    icon: icons2,
  },
  {
    title: "Student-Achiever Interaction",
    desc: "Direct interaction with serving & former civil servants.",
    icon: icons3,
  },
  {
    title: "Expert Faculty",
    desc: "Highly experienced UPSC-oriented mentors.",
    icon: icon4,
  },
  {
    title: "Extensive Test Series",
    desc: "Prelims & Mains tests evaluated on UPSC standards.",
    icon: icon5,
  },
  {
    title: "Complete Guidance",
    desc: "Mentorship from preparation to interview stage.",
    icon: icon6,
  },

  
];

const chunkArray = (arr, size) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

const cardSlides = chunkArray(whyChooseCards, 3);


  

//  useEffect(() => {
//     const duration = 3000; // 2 seconds
//     const endValue = 2700;
//     let start = 0;
//     const startTimestamp = performance.now();
//     const easeOutExpo = (t) =>
//       t === 1 ? 1 : 1 - Math.pow(2, -10 * t);  // trending smooth easing
//     const animate = (currentTime) => {
//     const elapsed = currentTime - startTimestamp;
//     const progress = Math.min(elapsed / duration, 1);
//     const easedProgress = easeOutExpo(progress);
//     const currentNumber = Math.floor(easedProgress * endValue);
//       setCount(currentNumber);

//       if (elapsed < duration) {
//         requestAnimationFrame(animate);
//       } else {
//         setCount(endValue); // final value
//         setShowPlus(true);
//       }
//     };

//     requestAnimationFrame(animate);
//   }, []);

  useEffect(() => {
    // Run only in browser (safe for Next.js)
    if (typeof window === "undefined") return;

    const shown = sessionStorage.getItem("notify");

    if (!shown) {
      console.log(" showing popup...");

      const timer = setTimeout(() => {
        console.log(" opening popup!");
        openModal();
        sessionStorage.setItem("notify", "true");
      }, 2000.500); 

      return () => clearTimeout(timer);
    } else {
      console.log("⚠️ Popup already shown this session — skipping.");
    }
  }, []);  

  const listRef = useRef(null);

  const smoothScroll = (element, distance, duration = 400) => {
  const start = element.scrollTop;
  const startTime = performance.now();

  const easeInOut = (t) =>
    t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;

  const animate = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    element.scrollTop =
      start + distance * easeInOut(progress);

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  };

  requestAnimationFrame(animate);
};


  const scrollUp = () => {
  smoothScroll(listRef.current, -140, 450);
};

const scrollDown = () => {
  smoothScroll(listRef.current, 140, 450);
};

  const [play, setPlay] = useState(false);
  const [play1, setPlay1] = useState(false);

  
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "Best IAS Coaching in India | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/",
    "logo":
      "https://www.shankariasacademy.com/_next/static/media/SIA%20Logo.f7bc4ef0.png",
    "description": "Join Shankar IAS Academy, the Best IAS Coaching in India, for expert mentorship, structured courses, and top success rates in UPSC and TNPSC.",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+91-7667766266",
        "contactType": "UPSC, TNPSC Admissions"
      },
      {
        "@type": "ContactPoint",
        "telephone": "044-66024500",
        "contactType": "UPSC, TNPSC Admissions"
      },
      {
        "@type": "ContactPoint",
        "telephone": "044-43533445",
        "contactType": "UPSC, TNPSC Admissions"
      },
      {
        "@type": "ContactPoint",
        "telephone": "044-45543082",
        "contactType": "UPSC, TNPSC Admissions"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/shankariasacademy",
      "https://twitter.com/shankarias",
      "https://www.instagram.com/shankariasacademy/",
      "https://www.youtube.com/c/ShankarIASAcademyVideos"
    ]
  }

  const handleButtonClick = () => {
    if (window.fbq) {
      window.fbq('track', 'ButtonClick');
    }
    // Your button click logic here
    console.log('Button clicked!');
  };
  return (
    <>
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <meta name="robots" content="noodp,noydir" />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="robots" content="noindex,nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
        <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
        <title>Best IAS Coaching in India | Shankar IAS Academy</title>
        <meta name="title" content="Best IAS Coaching in India | Shankar IAS Academy" />
        <meta name="keywords" content="" />
        <meta name="description" content="Join Shankar IAS Academy, the Best IAS Coaching in India, for expert mentorship, structured courses, and top success rates in UPSC and TNPSC." />
        <link rel="canonical" href="https://www.shankariasacademy.com/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Best IAS Coaching in India | Shankar IAS Academy" />
        <meta property="og:description" content="Join Shankar IAS Academy, the Best IAS Coaching in India, for expert mentorship, structured courses, and top success rates in UPSC and TNPSC." />
        <meta property="og:url" content="https://www.shankariasacademy.com/" />
        <meta property="og:site_name" content="Shankar IAS Academy" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@shankarias" />
    </Head>

  <Navbar title="home" />
 
  <Modal  size="md" centered show={modalIsOpen} onHide={closeModal}  aria-label="Course Modal"  className="blur">
    <Modal.Body className="p-4 position-relative rounded-5" style={{
    background: "linear-gradient(135deg, #fff2f2d1 0%, #b6eeff4a 100%)",
  }}>
    <button 
      className="btn btn-sm btn-light border position-absolute" 
      style={{ top: "10px", right: "10px", borderRadius: "50%" }}
      onClick={closeModal}
    >✕</button>
    
    <h4 className="fw-bold text-center mb-3 text-dark">
      Choose Your UPSC / TNPSC Course
    </h4>
    <p className="text-center text-muted mb-4">
      Choose your exam stream & start preparation with experts
    </p>

    <div className="p-3 mb-3 border rounded-4 shadow-sm bg-light">
      <h6 className="fw-bold  mb-2"> UPSC Courses <span><Image src={NewiconA} width="32" height="30" alt="New_icon" className="img-fluid mx-2" /></span></h6>
      
      <Link href="/upsc-admission-anna-nagar" className={`${styles.acheiverrank, styles.courseshover2}`}id="allindiaprelimshover1" onclick="fbq('track', 'ButtonClick');">
        <button  className="btn btn-outline-danger w-100 mb-2">Prelims + Mains Foundation</button>
      </Link>
      
      <Link href="/two-year-upsc-program" className={`${styles.acheiverrank, styles.courseshover2}`}id="allindiaprelimshover1" onclick="fbq('track', 'ButtonClick');">
        <button className="btn btn-outline-danger w-100 mb-2">Sadhana – 2 Yr Foundation</button>
      </Link>

      <Link href="/upsc-optional-programme/" className={`${styles.acheiverrank, styles.courseshover2}`}id="allindiaprelimshover1" onclick="fbq('track', 'ButtonClick');">
        <button onClick={() => router.push("/upsc/optional-2025")} className="btn btn-outline-danger w-100">Optional 2025</button>
      </Link>

    </div>

    <div className="p-3 border rounded-4 shadow-sm bg-light">
      <h6 className="fw-bold  mb-2">TNPSC Courses <span><Image src={NewiconA} width="32" height="30" alt="New_icon" className="img-fluid mx-2" /></span></h6>
      <Link href="/tnpsc-admissions/#gspcm" className={`${styles.acheiverrank, styles.courseshover2}`}id="allindiaprelimshover1" onclick="fbq('track', 'ButtonClick');">
          <button  className="btn btn-outline-primary w-100 mb-2">TNPSC Prelims cum Mains </button>
      </Link>

      <Link href="/upsc-admission-anna-nagar" className={`${styles.acheiverrank, styles.courseshover2}`}id="allindiaprelimshover1" onclick="fbq('track', 'ButtonClick');">
        <button  className="btn btn-outline-primary w-100 mb-2">Group 1 Prelims + Mains 2026</button>
      </Link>

      <Link href="/tnpsc-group-I-mains-mock-test" className={`${styles.acheiverrank, styles.courseshover2}`}id="allindiaprelimshover1" onclick="fbq('track', 'ButtonClick');">
        <button  className="btn btn-outline-primary w-100">Group 1 Mains Mock</button>
      </Link>
    </div>

    </Modal.Body>
  </Modal>

{/* For Large Device */}

<section>
  <div className="container pt-1 ">
    <div className="row mx-auto">
      <div  data-aos="fade-left" className="col-md-6 pt-2 mt-2">
            <div className={`${styles.coursesimg} row`} >
              <div className="d-flex flex-wrap justify-content-center gap-4 mb-4  pb-2">
                <Link href="/upsc-admission-anna-nagar" className="text-center pt-2">
                    <Image src={chennai} className={`${styles.logoimg} img-fluid`} alt="Chennai Icon" />
                    <button type="button" className="newnav d-block  mx-auto text-center">Tamilnadu</button>
                </Link>

                <Link href="/delhi" className="text-center pt-2">
                    <Image src={delhi} className={`${styles.logoimg} img-fluid`} alt="Delhi Icon" />
                    <button type="button" className={`${styles.delhibtn} newnav  d-block  mx-auto text-center`}>Delhi</button>
                </Link>

                <Link href="/bengaluru" className="text-center pt-2">
                    <Image src={bengaluru} className={`${styles.logoimg} img-fluid`} alt="Bengaluru Icon" />
                    <button type="button" className="newnav d-block  mx-auto text-center">Bengaluru</button>
                </Link>

                <Link href="/thiruvananthapuram" className="text-center pt-2">
                    <Image src={thiruvandram} className={`${styles.logoimg} img-fluid`} alt="Thiruvananthapuram Icon" />
                    <button type="button" className="newnav d-block  mx-auto text-center">Trivandrum</button>
                </Link>

                <Link href="/hyderabad" className="text-center pt-2">
                    <Image src={hyderabad} className={`${styles.logoimg} img-fluid`} alt="Hyderabad Icon" />
                    <button type="button" className="newnav d-block  mx-auto text-center">Hyderabad</button>
                </Link>
              </div> 
            </div> 

        <div className={styles.wrapper}>
          <div className={styles.tabRow}>
              <button
                className={`${styles.tabButton} ${activeTab === "upsc" ? styles.active : ""}`}
                onClick={() => setActiveTab("upsc")}
                > 
                UPSC
              </button>

              <button
                className={`${styles.tabButton} ${activeTab === "tnpsc" ? styles.active : ""}`}
                onClick={() => setActiveTab("tnpsc")}
                >
                TNPSC
              </button>

              <button
                className={`${styles.tabButton} ${activeTab === "banking" ? styles.active : ""}`}
                onClick={() => setActiveTab("banking")}
                >
                BANKING
              </button>

              <button
                className={`${styles.tabButton} ${activeTab === "new" ? styles.active : ""} d-none d-md-block`}
                onClick={() => setActiveTab("new")}
              > 
              WHAT’S NEW 

              </button>
          </div>

          {/* BOTTOM CARD */}
          <div className={`${styles.cardBox}`}>
          {activeTab === "upsc" && (
            <div className={styles.courseWrapper}>               
              <div
                className={styles.upArrow}
                onClick={scrollUp}
                role="button"
                aria-label="Scroll up">
              </div>

              <ul className={styles.courseList} ref={listRef}>
                <li className={styles.item}>
                  <Link
                    href="/upsc-admission-anna-nagar"
                    className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  >
                    UPSC - Foundation Course 
                  </Link>
                </li>

                <li className={styles.item}>
                  <Link
                    href="/all-india-upsc-prelims-mock-test"
                    className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  >
                    All India UPSC Prelims Mock Test 2026
                  </Link>
                </li>

                <li className={styles.itemRed}>
                  <Link
                    href="/upsc-optional-programme"
                    className={`${styles.acheiverrank} ${styles.courseshover3}`}
                  >
                    UPSC Optional Programme 2026
                  </Link>
                </li>

                 <li className={styles.item}>
                  <Link
                    href="/upsc-prelims-test-series"
                    className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  >
                    UPSC Prelims Test Series 2026 
                  </Link>
                </li>


                <li className={styles.item}>
                  <Link
                    href="/current-affairs-upsc"
                    className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  >
                    UPSC Chakra Current Affairs Programme 2026
                  </Link>
                </li>

                
                <li className={styles.item}>
                  <Link
                    href="/two-year-upsc-program"
                    className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  >
                    Sadhana (II Year UPSC Foundation Course)
                  </Link>
                </li> 

                  <li className={styles.item}>
                  <Link
                    href="/upsc-environment-book"
                    className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  >
                    UPSC Environment Book Buy Now
                  </Link>
                </li> 

              </ul>
            
              <div
                className={styles.downArrow}
                onClick={scrollDown}
                role="button"
                aria-label="Scroll down">
              </div>
            </div>
          )}


          {/* TNPSC COURSES */}

          {activeTab === "tnpsc" && (
          <div className="">
            <div className={styles.upArrow}></div>
              <li className={styles.item}>
                <Link
                  href="/tnpsc-admissions"
                  className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  id="upsc-ias-ips-admissioncourseshover2"
                  onClick={() => fbq('track', 'ButtonClick')}
                >
                  TNPSC Group I & II Preliminary Course 2025
                </Link>
              </li>

              <li className={styles.itemRed}>
                <Link
                  href="/tnpsc-group-II-IIA-prelims-test-series"
                  className={`${styles.acheiverrank} ${styles.courseshover3}`}
                  id="upsc-ias-ips-admissioncourseshover2"
                  onClick={() => fbq('track', 'ButtonClick')}
                >
                  I'M TOP TNPSC Group II/IIA Prelims Test Series 2026
                </Link>
              </li>

              <li className={styles.item}>
                <Link
                  href="/tnpsc-general-english-workshop"
                  className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  id="upsc-ias-ips-admissioncourseshover2"
                  onClick={() => fbq('track', 'ButtonClick')}
                >
                  I'M TOP TNPSC General English Workshop 2026
                </Link>
              </li>

              <li className={styles.item}>
                <Link
                  href="/tnpsc-group-i-prelims-test-series/"
                  className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  id="upsc-ias-ips-admissioncourseshover2"
                  onClick={() => fbq('track', 'ButtonClick')}
                >
                I'M TOP TNPSC Group I Prelims Test Series 2026
                </Link>
              </li>
            <div className={styles.downArrow}></div>
          </div>
          )}

          {/* Banking COURSES */}
          {activeTab === "banking" && (
          <div className="">
            <div className={styles.upArrow}></div>
              <li className={styles.item}>
                <Link
                  href="https://www.shankarbankingacademy.com/ssc-banking-admission/"
                  className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  id="upsc-ias-ips-admissioncourseshover2"
                  onClick={() => fbq('track', 'ButtonClick')}
                >
                  BANKING / SSC Admission 2025
                </Link>
              </li>

              <li className={styles.itemRed}>
                <Link
                  href="https://www.shankarbankingacademy.com/ssc-banking-admission/"
                  className={`${styles.acheiverrank} ${styles.courseshover3}`}
                  id="upsc-ias-ips-admissioncourseshover2"
                  onClick={() => fbq('track', 'ButtonClick')}
                >
                  SSC CGL CRASH COURSE 2025
                </Link>
              </li>

              <li className={styles.item}>
                <Link
                  href="https://docs.google.com/forms/d/e/1FAIpQLScbuMAAHtWmKUnwL0_AKHhCM-RzWzfZ6nlKlCsERVOX5PjRQQ/viewform"
                  className={`${styles.acheiverrank} ${styles.courseshover2}`}
                  id="upsc-ias-ips-admissioncourseshover2"
                  onClick={() => fbq('track', 'ButtonClick')}
                >
                  IBPS PO MOCK INTERVIEW 2025
                </Link>
              </li>
            <div className={styles.downArrow}></div>
          </div>
          )}
          </div>
        </div>
      </div>

      <div  data-aos="fade-right" className="col-md-6 pt-3">
        <Slider />
      </div>  
    </div>
  </div>
</section>

  {/* New Achievment */}
<section data-aos="zoom-in">
  <div className="container pt-4">
    <div className={`${styles.bestbg}`}>
      <div className="row g-4 mt-2">        
        <div className="col-12  col-lg-2">
          <div className={`${styles.acheivement}`}>
            <div className= {`${styles.mdeal}  d-none col-12 text-center`}>
              <Image src={medal} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" />
            </div>
            <h2 className="md-pt-5 lg-pt-4"><span style={{ color: "#fd1212ff", fontWeight:"bold" }}>Our </span><br/>
            Achievements</h2>
          </div>
        </div>

        <div className="col-12 col-md-4 col-lg-3 offset-lg-1" data-aos="zoom-in" data-aos-delay="400">
          <div className={`${styles.newachievernumber} text-center`}>
            <h5>
              <CountUp end={2900} duration={3.5} suffix="+" />
            </h5>
            <p className="text-center">
              Candidates selected for <br/>
              IAS, IPS, IFS and other <br/>
              Elite Services from our institute
            </p>
          </div>
        </div>

        <div className="col-12 col-md-3 col-lg-2">
          <div className={`${styles.newachievernumber} text-center`} data-aos="zoom-in" data-aos-delay="500">
            <h5>
              <CountUp end={2000} duration={3.5} suffix="+" />
            </h5>
            <p className="text-center">
              Candidates selected for <br/>
              Group I, II and IV services from our Institute
            </p>
          </div>
        </div>

        <div className="col-12 col-md-3 col-lg-2">
          <div className={`${styles.newachievernumber1} text-center`} data-aos="zoom-in" data-aos-delay="400">
            <h5>
              <CountUp end={1000} duration={3.5} suffix="+" />
            </h5>
            <p className="text-center">
              Candidates selected across Various <br/>
              Banks from our Institute
            </p>
          </div>
        </div>

        <div className="col-12 col-md-1 col-lg-2 ">
          <div className={`${styles.newachievernumber1} text-center pt-4`}>
            <Link href="/our-achievers" className={`${styles.acheivermore}`} id=""  onclick="fbq('track', 'ButtonClick');">
              <b><span style={{ color: "rgb(94, 87, 87)", fontWeight:"bold" }}>& More</span></b> <Image src={redrightarrow} className={`${styles.logoimg} img-fluid`} alt="Chennai Icon" width={20} height={20} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


  {/* Our Events  */}
<section className="pt-3"style={{background: "linear-gradient(135deg, #fff2f2d1 0%, #b6eeff4a 100%)", }} >
  <div className="container " >
    <div className="row mx-auto pt-4" >
       <h3 className={styles.headingWrapper}>
        <span className={styles.heading3d}>Our Events</span>
      </h3>
      <div  data-aos="fade-up" className="col-12 col-md-5  mt-4 pe-0">
        <div className={`${styles.roadmapStart}`} >
          <p><span style={{ color: '#000',  }}>Shankar IAS Academy </span> is the top coaching institute for IAS in Chennai and the best UPSC coaching in India, providing excellent coaching for UPSC aspirants. Being the<span> best IAS coaching in chennai,</span> we provide expert faculty, comprehensive study material and a systematic approach to help the students to succeed.
           Being recognized among the best IAS academy in chennai, our courses are designed to the minutest detail, the syllabus coverage is extensive and the mentoring is personalized to provide the best preparation for the exam. Our dedicated support helps the students to solve the IAS exam with confidence.
          </p>
        </div>

        <div className={`${styles.newachievernumber1} pb-2`}>
          <Link href="https://www.shankariasacademy.com/blog/institute-day-2024-20-years-celebration/" className={`${styles.acheivermore}`} id=""  onclick="fbq('track', 'ButtonClick');" >
            <b><span style={{fontSize:"14px", fontWeight:"bold" }}> SEE MORE </span></b> <Image src={redrightarrow} className={`${styles.logoimg} img-fluid`} alt="Chennai Icon" width={20} height={20} />
          </Link>
        </div>
      </div>

      <div data-aos="fade-down" className="col-12 col-md-6 offset-md-1  col-12  justify-content-center">
        <div className="row mx-auto">
          <div className={styles.eventsRoot}>
            <div className={styles.sliderWrapper} onMouseLeave={() => setActive(0)}>
              <div className={styles.eventsRow}>
                {events.map((item, index) => (
                  <div key={index} className={`${styles.card} ${active === index ? styles.active : ""}`} onMouseEnter={() => setActive(index)}>    
                    <div style={{ position: "relative", width: "100%", height: "100%" }}>
                      <div className={styles.imageWrapper}>
                        <Image
                          src={item.img}
                          alt={item.title}
                          layout="fill"        
                          objectFit="cover"
                          priority={index === 0}
                        />
                      </div>
                    </div>
                    <h5 className={styles.title}>{item.title}</h5>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section >
  <div className="container" >
    <div className="row align-items-center  rounded-4 shadow-sm p-4">
      
       {/* Image */}
      <div data-aos="fade-down" className="col-lg-6 text-center">
        <div className={styles.indiamap}>
          <Image
            src={SIAINDIA}
            alt="Best IAS Academy in India"
            title="Best IAS Academy in India"
            className="img-fluid rounded-3"
          />
        </div>
      </div>

      {/* Content */}
      <div data-aos="fade-right" className="col-lg-6">  
        <div className="row"> 
          <div  className="col-lg-8"> 
            <h3 className={`${styles.branchtitle} text-center text-lg-start mb-3`}>From Aspirant to Officer <span> <br/>Shaping India’s Future.</span> </h3>
          </div>

          <div  className=" col-lg-4 text-center">
            <Link href={"/contact-us"} rel="preconnect" className={`${styles.viewbuttonalink}`}>
              <button type="button" className={`${styles.viewbutton}`} >
                  Contact Us
              </button>
            </Link>
          </div>

        </div>
        <p className={`${styles.sectiontext} mb-3`}>
          All over India, people aspiring to become IAS, IPS and other elite bureaucratic service officers and seeking to fine tune their preparation, flock to Shankar IAS Academy for Civil Service coaching. With branches in
          Chennai, Delhi, Bengaluru, Hyderabad, Thiruvananthapuram, Trichy, Salem, Madurai, Namakkal and Coimbatore, it is the Academy of choice for Civil Service aspirants.
        </p>

        <p className={styles.sectiontext}>
          <span style={{ color: "#d61919",}}>Shankar IAS Academy</span> is the top coaching institute for IAS in Chennai
          and among the best UPSC coaching institutes in India. We offer expert faculty,
          comprehensive study material, and a systematic approach to help aspirants succeed.
          Recognized as the best IAS academy in Chennai, our courses are designed with
          meticulous syllabus coverage and personalized mentoring to ensure confident
          performance in the IAS examination.
        </p>
      </div>
    </div>
  </div>
</section>

  {/* Whychoose Card Section Whychoose */}

<section className=""style={{background: "linear-gradient(135deg, #fff2f2d1 0%, #b6eeff4a 100%)",}} >
    <div  className="container  pt-5">
        <div className="row mx-auto">
          <h3 className={styles.headingWrapper}>
            <span className={styles.heading3d}>Announcement Banner</span>
          </h3>
          <Whychoose/>
        </div>
    </div>
</section>

  {/* Announcement Slide  Banner Section  */}

<section  className="pt-5 "style={{background: "linear-gradient(135deg, #fff2f2d1 0%, #b6eeff4a 100%)",}}>
      <div className="container">
        <div className="row align-items-stretch">
          {/* LEFT BUTTONS */}
          <div data-aos="zoom-in" className="col-12 col-md-2 col-lg-2 p-0">
            <div className={styles.newbtn}>
              {banners.map((banner, index) => (
                <button
                  key={index}
                  className={`${styles.tabredButton} ${
                    activeIndex === index ? styles.active1 : ""
                  }`}
                  onClick={() => setActiveIndex(index)}
                >
                  <span className={styles.btnText}>{banner.label}</span>
                  <span className={styles.btnArrow}>›</span>
                </button>
              ))}
            </div>
          </div>

      {/* SLIDER */}
      
        <div data-aos="zoom-in" className="col-12 col-md-8 col-lg-8 p-0">
          <div className={styles.sliderWrapper}>
            <div
              className={styles.sliderTrack}
              style={{
                transform: `translateX(-${activeIndex * 80}%)`,
              }}
            >
              {banners.map((e, index) => (
                <div
                  key={index}
                  className={`${styles.slide} ${
                    index === activeIndex
                      ? styles.activeSlide
                      : styles.queueSlide
                  }`}
                >
                  <Link href={e.link}>
                    <Image
                      src={e.img}
                      alt={e.alt}
                      className={styles.slideImage}
                      priority={index === activeIndex}
                    />
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
</section>

   {/* Why Choose   Shankar IAS Academy Section  */}

 <section className="py-5"style={{background: "linear-gradient(135deg, #fff2f2d1 0%, #fff8ea 100%)",}}>
  <div className="container">
    <div className="row align-items-center">
      <div data-aos="fade-right" className="col-12 col-md-2 ">
        <h3 className="d-none d-md-block">
          Why<br />
          Choose<br />
          <span style={{ color: "#fd1212ff", fontWeight: "700" }}>
            Shankar IAS<br />Academy
          </span><br />
          among<br /> others?
        </h3>

        <h3 className="d-block d-md-none text-center">
          Why Choose{" "}
          <span style={{ color: "#fd1212ff", fontWeight: "700" }}>
            Shankar IAS Academy
          </span>{" "}
          among others?
        </h3>
      </div>

      {/* RIGHT CARD CAROUSEL */}
      <div  className="col-12 col-md-10 ">
        <Carousel
          interval={6000}
          indicators={false}
          controls={false}
          pause="hover"
          activeIndex={activeSlide}
          onSelect={(selectedIndex) => setActiveSlide(selectedIndex)}
        >
          {cardSlides.map((slide, index) => (
            <Carousel.Item key={index}>
                <div className="row g-3">
                  {slide.map((card, i) => (
                    <div className="col-md-4" key={i}>
                      <div className={styles.whychooseBox}>
                        <Image src={card.icon} width={69} height={69} alt={card.title} />
                        <h5 className="pt-2 fw-bold">{card.title}</h5>
                        <p className={styles.acheiverrank}>{card.desc}</p>
                      </div>
                    </div>

                  ))}
                </div>
            </Carousel.Item>
          ))}
        </Carousel>

        <div className={`${styles.carouselnavwrapper} mt-2 pt-2`}>
          <button className={styles.navarrow}
            onClick={() =>
            setActiveSlide(
            activeSlide === 0 ? cardSlides.length - 1 : activeSlide - 1 )
            }
          >
              ‹
          </button>

          <div className={styles.navdots} >
            {cardSlides.map((_, i) => (
              <span
                key={i}
                className={`${styles.dot} ${
                activeSlide === i ? styles.dotActive : ""
                }`}
                onClick={() => setActiveSlide(i)}
              />
            ))}
          </div>

          <div className={styles.navdots}>
            {cardSlides.map((_, i) => (
              <span
                key={i}
                className={`dot ${activeSlide === i ? "active" : ""}`}
                onClick={() => setActiveSlide(i)}
              />
            ))}
          </div>

          <button
            className={styles.navarrow}
            onClick={() =>
              setActiveSlide(
              activeSlide === cardSlides.length - 1 ? 0 : activeSlide + 1
                )
              }
            >
              ›
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

  {/*Desktop view  */}
 <section className="py-5 d-none d-md-none d-lg-block">
  <div className={styles.circleWrap}>
    <div className={styles.centerImage}>
        <div data-aos="zoom-in"  className="clock-wrapper col text-center pt-4">
          <Image src={SIAHOME} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" />
      </div>       
    </div>

    <div data-aos="zoom-out-right" className={`${styles.circleItem} ${styles.topLeft} ${styles.active1}`}>
      <p>Personalised And Scientific Mentoring</p><span><Image src={homeicon4} width="56" height="56" alt="New_icon" className="img-fluid mx-2" /></span> 
    </div>

    <div data-aos="zoom-out-right" className={`${styles.circleItem} ${styles.left} ${styles.active2}`}>
      <p>Experienced Faculty Team (10+ Years)</p><span><Image src={homeicon3} width="56" height="56" alt="New_icon" className="img-fluid mx-2" /></span> 
    </div>

    <div data-aos="zoom-out-right" className={`${styles.circleItem} ${styles.bottomLeft} ${styles.active3}`}>
      <p>Regular Guidance From Achievers</p><span><Image src={homeicon2} width="66" height="66" alt="New_icon" className="img-fluid mx-2" /></span> 
    </div>

    <div data-aos="zoom-out-left" className={`${styles.circleItem} ${styles.topRight} ${styles.active}`}>
      <span><Image src={homeicon1} width="66" height="66" alt="New_icon" className="img-fluid mx-2" /></span> 
      <span className={styles.circleItemText}><p>Consistently Producing Toppers  Since 2004</p></span>
    </div>

    <div data-aos="zoom-out-left" className={`${styles.circleItem} ${styles.right} ${styles.active5}`}>
      <span><Image src={homeicon5} width="56" height="56" alt="New_icon" className="img-fluid mx-2" /></span> 
      <p>AI Based Test Series<br/> (100+ Prelims, 20+ Mains)</p> 
    </div>

    <div data-aos="zoom-out-left" className={`${styles.circleItem} ${styles.bottomRight} ${styles.active6}`}>
      <span><Image src={homeicon6} width="116" height="116" alt="New_icon" className="img-fluid mx-2" /></span> 
      <p>3 Months Interview Program With Coaching And Mock Interviews.</p>
    </div>
  </div>
  <div className="row mx-auto">
    <div className="">
        <div className="container pt-4">
            <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-md-8">
                  <p className={`${styles.acheiverrank} text-center mb-0`}>
                    <span style={{color:"#e31124" , fontFamily:"Switzer-Bold"}}>Shankar IAS Academy </span> stands as the best academy for TNPSC and UPSC coaching, offering a holistic,<br/>
                     structured, and result-oriented approach to civil services preparation. With an elite faculty,<br/> large test series,
                     interactive class learning, and government trust, we provide every aspirant with the<br/> best guidance possible to pursue their IAS aspirations.
                  </p>
                </div>
            </div>
            <div className="col py-4 text-center">
                <Link href={"/why-shankar-ias"} rel="preconnect" className={`${styles.viewbuttonalink}`}>
                  <button type="button" className={`${styles.viewbutton}`}>
                    Know More
                  </button>
                </Link>
            </div>
        </div>
    </div>
  </div> 
</section>

{/* Tap view */}
<section className="py-3 d-none d-md-block d-lg-none"style={{background: "linear-gradient(135deg, #fff2f2d1 0%, #b6eeff4a 100%)", }}>
  <div className={styles.circleWrap}>
    <div className={styles.centerImage}>
        <div className="col text-center pt-4">
          <Image src={SIAHOME} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" />
      </div>       
    </div>

    <div className={`${styles.circleItem} ${styles.topLeft} ${styles.active1}`}>
      <p>Personalised And Scientific Mentoring</p><span><Image src={homeicon4} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span> 
    </div>

    <div className={`${styles.circleItem} ${styles.left} ${styles.active2}`}>
      <p>Experienced Faculty Team (10+ Years)</p><span><Image src={homeicon3} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span> 
    </div>

    <div className={`${styles.circleItem} ${styles.bottomLeft} ${styles.active3}`}>
      <p>Regular Guidance From Achievers</p><span><Image src={homeicon2} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span> 
    </div>

    <div className={`${styles.circleItem} ${styles.topRight} ${styles.active}`}>
      <span><Image src={homeicon1} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span> 
      <span className={styles.circleItemText}><p>Consistently Producing Toppers  Since 2004</p></span>
    </div>

    <div className={`${styles.circleItem} ${styles.right} ${styles.active5}`}>
      <span><Image src={homeicon5} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span> 
      <p>AI Based Test Series<br/> (100+ Prelims, 20+ Mains)</p> 
    </div>

    <div className={`${styles.circleItem} ${styles.bottomRight} ${styles.active6}`}>
      <span><Image src={homeicon6} width="86" height="86" alt="New_icon" className="img-fluid mx-2" /></span> 
      <p>3 Months Interview Program With Coaching And Mock Interviews.</p>
    </div>
  </div>

  <div className="row mx-auto">
    <div className="mb-5">
      <div className="container pt-4">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-md-8">
            <p className={`${styles.acheiverrank} text-center mb-0`}>
              <span style={{color:"#e31124" , fontFamily:"Switzer-Bold"}}>Shankar IAS Academy </span> stands as the best academy for TNPSC and UPSC coaching, offering a holistic,<br/>
              structured, and result-oriented approach to civil services preparation. With an elite faculty,<br/> large test series,
              interactive class learning, and government trust, we provide every aspirant with the<br/> best guidance possible to pursue their IAS aspirations.
            </p>
          </div>
        </div>

        <div className="col py-5 text-center">
          <Link href={"/why-shankar-ias"} rel="preconnect" className={`${styles.viewbuttonalink}`}>
            <button type="button" className={`${styles.viewbutton}`}>
              Know More
            </button>
          </Link>
        </div>
      </div>
    </div>
  </div> 
</section>


{/*Mobile view */}
<section className="py-5 d-block d-md-none d-lg-none"style={{background: "linear-gradient(135deg, #fff2f2d1 0%, #b6eeff4a 100%)", }}>
  <div className="container">
    <div className="row">
        <div className={`${styles.circleItem} col-12`}>
          <span>
            <Image
              src={homeicon4}
              width="56"
              height="56"
              alt="New_icon"
              className="img-fluid mx-2"
            />
          </span>
          <p>Personalised And Scientific Mentoring</p>

      <div className={styles.slidedownArrow}></div>
    </div>


        <div className= {`${styles.circleItem} mt-4 col-12 `}>
           <span><Image src={homeicon3} width="56" height="56" alt="New_icon" className="img-fluid mx-2" /></span>  <p>Experienced Faculty Team (10+ Years)</p>
        <div className={styles.slidedownArrow}></div>
        </div>

        <div className= {`${styles.circleItem}  ${styles.active} mt-4 col-12 `}>
           <span><Image src={homeicon2} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span>  <p>Regular Guidance From Achievers</p>
         <div className={styles.slidedownArrow}></div>
        </div>

        

        <div className= {`${styles.circleItem}  mt-4 col-12 `}>
          <span><Image src={homeicon1} width="56" height="56" alt="New_icon" className="img-fluid mx-2" /></span> 
           <p>Consistently Producing Toppers  Since 2004</p>
          <div className={styles.slidedownArrow}></div>
        </div>

        <div className= {`${styles.circleItem} mt-4 col-12 `}>
            <span><Image src={homeicon5} width="56" height="56" alt="New_icon" className="img-fluid mx-2" /></span> 
            <p>AI Based Test Series (100+ Prelims, 20+ Mains)</p> 
         <div className={styles.slidedownArrow}></div>
        </div>

        <div className= {`${styles.circleItem} mt-4 col-12 `}>
            <span><Image src={homeicon6} width="56" height="56" alt="New_icon" className="img-fluid mx-2" /></span> 
            <p>3 Months Interview Program With Coaching And Mock Interviews.</p>
        </div>
      </div>
    </div>
</section>
 

{/* Our Government Collaborations */}
<section className=" pb-4" style={{background: "linear-gradient(135deg, #fff2f2d1 0%, #fff8ea 100%)",}}>
  <div className="container ">
      <div className="row justify-content-center align-items-center flex-wrap">
        <h3 className={`${styles.headingWrapper1} pb-5`}>
          <span className={styles.heading3d}>Our Government Collaborations</span>
        </h3>
        
          <div className= {`${styles.civillogo}  col-md-2 text-center`}> 
              <Image src={Inidia} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" width={'80'} height={'80'} />
              <p>Ministry of Social Justice and Empowerment </p>
          </div>

          <div className= {`${styles.civillogo} col-md-2 text-center`}> 
              <Image src={Karnataka} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" width={'80'} height={'80'} />
              <p> Government of Karnataka,  2019, 2023 & 2024</p> 
          </div>

          <div className= {`${styles.civillogo} col-md-2 text-center`}> 
              <Image src={Bengal} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" width={'80'} height={'80'} />
              <p> Government of West Bengal, <br/> 2021 to 2024</p>
          </div>

          <div className= {`${styles.civillogo} col-md-2 text-center`}> 
              <Image src={Kerala} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" width={'80'} height={'80'} />
              <p>Government of Kerala,<br/> 2023-24</p>
          </div>
        
          <div className= {`${styles.civillogo} col-md-2 text-center`}> 
              <Image src={Himachal} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" width={'80'} height={'80'} />
              <p> Government of Himachal Pradesh , <br/> 2024</p>
          </div>

          <div className="row justify-content-center align-items-center flex-wrap">

          <div className= {`${styles.civillogo} col-md-2 text-center`}> 
              <Image src={Meghalaya} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" width={'80'} height={'80'} />
              <p> Government of Meghalaya<br/> 2024</p>
          </div>

          <div className= {`${styles.civillogo} col-md-2 text-center`}> 
              <Image src={Andhra} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" width={'80'} height={'80'} />
              <p>YSR Vidyonnathi Government of Andhra Pradesh, 2019</p> 
          </div>

          <div className= {`${styles.civillogo} col-md-2 text-center`}>
              <Image src={Kashmir} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" width={'80'} height={'80'} />
              <p>Government of Jammu  & Kashmir , 2024</p> 
          </div>

          <div className= {`${styles.civillogo} col-md-2 text-center`}>
              <Image src={HimachalPradesh} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" width={'80'} height={'80'} />
              <p>Government of Himachal Pradesh, 2024</p>
          </div>

          <div className= {`${styles.civillogo} col-md-2 text-center`}>
              <Image src={Collaboration} alt="Our Achievements" title="Best IAS Academy in India" className="img-fluid" width={'80'} height={'80'} />
              <p>Our Collaboration With These  State Governments Reflects Our  Commitment to Quality    Education and Successful Outcomes</p>
          </div>
          </div>
      </div>
  </div> 
</section>

{/* Add Video Section  */}

<section className="py-5">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-6 col-md-8 col-12 text-center">
        <div className={styles.redbg} >       
        <div className={styles.attractStage}>
          <span className={styles.haloOne}></span>
          <span className={styles.haloTwo}></span>

          <div data-aos="zoom-in" className={styles.videoPortrait}>
           <div ref={sectionRef} >
                <video
                  ref={videoRef}
                  src="https://stage.shankariasacademy.com/stagehome/SIA-Tamilnadu-Toppers.mp4"
                  playsInline
                  preload="metadata"
                  width="100%"
                  height="500"
                 
                />
            </div>
          </div>

          <div className={`${styles.feature} ${styles.topLeftcircle} ${styles.leftBox}`}>
            <Image src={Webex} width="46" height="46" alt="New_icon" className="img-fluid mx-2 pb-2" />
            <h5>Live Online Classes</h5>
            <p>Interactive live classes for UPSC, TNPSC & Banking.</p>
          </div>

          <div className={`${styles.feature1} ${styles.topRightcircle} ${styles.rightBox}`}>
            <h5><Image src={Testpress} width="46" height="46" alt="New_icon" className="img-fluid mx-2 pb-2" />Online Test Portal </h5>
            {/* <p>Attend live practice tests anytime, anywhere for UPSC and TNPSC, designed to simulate real exam conditions.</p> */}
          </div>

           <div className={`${styles.feature} ${styles.bottomRightcircle} ${styles.rightBox1}`}>
              <Image src={Mobileapp} width="46" height="46" alt="New_icon" className="img-fluid mx-2 pb-2" />
              <h5>View Recorded Sessions</h5>
              <p>Learn anytime with the SIA Android app. Recorded classes available.</p>
          </div>

          <div className={`${styles.feature1} ${styles.bottomLeftcircle} ${styles.leftBox1}`}>
              <h5><Image src={onlineinterview} width="46" height="46" alt="New_icon" className="img-fluid mx-2 pb-2" /> Online Interview Guidance </h5>
          </div>

        </div>
        </div> 
      </div>
    </div>
  </div>
</section>

{/* Our Acheivers */}
  <div className="container">
    <div className="row">
      <div className="col pt-4 pt-md-5 text-center">
        <h2 className={`${styles.sectiontitle} mb-0`}>
          <span style={{ color: "#fd1212ff", fontWeight: "700" }}>O</span>ur  <span style={{ color: "#fd1212ff", fontWeight: "700" }}>A</span>chievers</h2>
        <p className={`${styles.sectionsubtitle}`}>
           Rank Holders from our Academy
        </p>
      </div>
    </div>
  </div> 
  
{/* Our Achievers Photos */}

<Acheiver />

  <div className=" container-fluid py-3 ">
    <div className="row reveal">
      <div className="container">
        <div className="row">
          <div className="col text-center">
            <h2 className={`${styles.sectiontitle} mb-0`}><span style={{ color: "#fd1212ff", fontWeight: "700" }}>T</span>estimonials</h2>
            <p className={`${styles.sectionsubtitle}`}>
              Hear it from our Achievers
            </p>
          </div>
        </div>

        <div className="ps-0 pe-0">
          <div className="container mb-2 ">
            <div className="row">
              <div className="col-12 col-lg-6 my-md-3 px-xl-3">
                {
                  play ?
                  (<iframe src={"https://www.youtube.com/embed/Xwj4MXW1REw?si=XzLmpvMcARGUq-Bu"} className="w-100 h-100  mb-md-3" id="homeyoutube" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ borderWidth: '0' }}></iframe>)
                        :
                  (<Image src={youtube_thumnail_3} style={{ cursor: 'pointer' }} onClick={() => setPlay(true)} className="img-fluid h-100 w-100  mb-md-3"
                    id="homeyoutube" alt="youtube thumbnail"></Image>)
                }
                <div className="d-none d-md-block">
                  <Link
                      href="https://www.shankariasparliament.com/upsc-current-affairs-videos"
                      target="_blank"
                      className={`${styles.acheiverrank, styles.courseknowmore} float-end`}
                    >
                      All Current Affairs
                  </Link>
                </div>
              </div>

              <div className="col-12 col-lg-6 pt-3 pt-md-0 my-md-3 px-xl-3">
                {
                  play1 ?
                  (<iframe src={"https://www.youtube.com/embed/bqo8k2FkoDk?si=ChYpUCnpgLNo900X"} className="w-100 h-100" id="homeyoutube" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ borderWidth: '0' }}></iframe>)
                        :
                  (<Image src={youtube_thumnail_2} style={{ cursor: 'pointer' }} onClick={() => setPlay1(true)} className="img-fluid h-100 w-100"
                          id="homeyoutube" alt="youtube thumbnail"></Image>)
                }
              </div>
            </div>

            <div className="pt-3 d-block d-md-none"><Link
                  href="https://www.iasparliament.com/UPSC-IAS-daily-current-videos"
                  target="_blank"
                  className={`${styles.acheiverrank, styles.courseknowmore}`}
                >
                  All Current Affairs
                </Link>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col  text-center">
            <Link href={"https://youtube.com/playlist?list=PLolj3WrQmJe4Ggl3bVf0QOy9-ebwAUt7d&si=oqQdk1FJVBDHDTMw"} target={"_blank"} rel="preconnect" className={`${styles.viewbuttonalink}`}>
              <button type="button" className={`${styles.viewbutton}`}>
                View All
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div> 

      {/* Why Shankar IAS Academy */}
      {/*<div className="container pt-md-5 pt-4">
        <div className="row">
          <div className="col">
            <h1 className={`${styles.sectiontitle} text-center mb-0`}>
              Why Shankar IAS Academy?
            </h1> 
          </div>
        </div>
      </div>*/}

      {/* <div className="container pt-md-5 pt-4">
        <div className="row">
          <div className="col-md-6 col-lg-4 mb-3 mb-md-4 col-12">
            <div className="p-3 p-md-4 h-100 d-flex align-items-center" style={{ backgroundColor: "#33527D" }}>
              <Link href="/our-achievers"><Image src={icon1} alt="Tnpsc & upsc toppers" title="Shankar IAS Academy Toppers" className="img-fluid" /></Link>              <div className="mx-3 mx-md-4">
                <a href="/our-achievers" className={`${styles.whyshankarcont} text-start mb-0 text-decoration-underline`}>Consistently Producing Toppers Since 2004</a>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 mb-3 mb-md-4 col-12">
            <div className="p-3 p-md-4 h-100 d-flex align-items-center" style={{ backgroundColor: "#C74A51" }}>
              <Link href="/our-faculty"><Image src={icon2} alt="Shankar IAS Academy faculty" title="Experienced Faculty Team" className="img-fluid" /></Link>              <div className="mx-3 mx-md-4">
                <a href="/our-faculty" className={`${styles.whyshankarcont} text-start mb-0 text-decoration-underline`}>Experienced Faculty Team (10+ Years)</a>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 mb-3 mb-md-4 col-12">
            <div className="p-3 p-md-4 h-100 d-flex align-items-center" style={{ backgroundColor: "#33527D" }}>
              <Image src={icon3} alt="Tnpsc & upsc achievers" title="Shankar IAS Academy Achievers" className="img-fluid" />
              <div className="mx-3 mx-md-4">
                <p className={`${styles.whyshankarcont} text-start mb-0`}>Regular Guidance From Achievers</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 mb-3 mb-md-4 col-12">
            <div className="p-3 p-md-4 h-100 d-flex align-items-center" style={{ backgroundColor: "#C74A51" }}>
              <Image src={icon4} alt="Tnpsc & upsc Mentoring" title="Shankar IAS Academy Personalised And Scientific Mentoring" className="img-fluid" />
              <div className="mx-3 mx-md-4">
                <p className={`${styles.whyshankarcont} text-start mb-0`}>Personalised And Scientific Mentoring</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 mb-3 mb-md-4 col-12">
            <div className="p-3 p-md-4 h-100 d-flex align-items-center" style={{ backgroundColor: "#33527D" }}>
              <Image src={icon5} alt="Tnpsc & upsc Test Series" title="Shankar IAS Academy Test Series" className="img-fluid" />
              <div className="mx-3 mx-md-4">
                <p className={`${styles.whyshankarcont} text-start mb-0`}>AI Based Test Series (100+ Prelims, 20+ Mains)</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 mb-3 mb-md-4 col-12">
            <div className="p-3 p-md-4 h-100 d-flex align-items-center" style={{ backgroundColor: "#C74A51" }}>
              <Image src={icon6} alt="Tnpsc & upsc Interview Program" title="Shankar IAS Academy Interview Program With Coaching And Mock Interviews." className="img-fluid" />
              <div className="mx-3 mx-md-4">
                <p className={`${styles.whyshankarcont} text-start mb-0`}>3 Months Interview Program With Coaching And Mock Interviews.</p>
              </div>
            </div>
          </div>

          <p className={`${styles.whyshankarcontnew}  mb-0 pt-2`}> Shankar IAS Academy stands as the <span style={{ color: '#d61919',  }}> best academy for TNPSC and  UPSC </span> coaching, offering a holistic, structured, and result-oriented approach to civil services preparation. With an elite faculty, large test series, interactive class learning, and government trust, we provide every aspirant with the best guidance possible to pursue their IAS aspirations.</p>

          <div className="row">
            <div className="col py-3 text-center">
              <Link href={"/why-shankar-ias"} rel="preconnect" className={`${styles.viewbuttonalink}`}>
                <button type="button" className={`${styles.viewbutton}`}>
                  Know More
                </button>
              </Link>
            </div>
          </div>

        </div>
      </div> */}

      {/* <div className="container pt-3">
        <div className="col text-center">
          <p className={`${styles.civilserviveheading}`}>
            PREFERRED CIVIL SERVICES TRAINING PARTNER OF
          </p>
        </div>
      </div> */}

      
      <Footer />
    </>
  );
};

export default Homepage;
